import React, { FC, useEffect } from "react";
import { StatCard, TStatCard } from "kw/admin/components/StatCard";

import { HeadingActionsBar } from "kanopi-components/HeadingActionBar/HeadingActionsBar";
import { HorizontalSpacer } from "kanopi-components/SpaceWrapper/HorizontalSpacer";
import { Placeholder } from "kanopi-components/Placeholder";
import { VerticalSpacer } from "kanopi-components/SpaceWrapper/VerticalSpacer";
import { useStats } from "kw/admin/hooks/useStats";

export type TDashboardStats = {
  totalQuotes: TStatCard;
  quotesThisMonth: TStatCard;
  policiesByStatus: TStatCard;
  policiesRenewed: TStatCard;
  totalActivePolicies: TStatCard;
  totalCustomers: TStatCard;
  totalGwp: TStatCard;
  claimsPayout: TStatCard;
  conversionRate: TStatCard;
  totalClaims: TStatCard;
};

export const DashboardPage: FC = () => {
  const { stats, loading, fetchStats } = useStats();

  useEffect(() => {
    fetchStats();
  }, []);

  return (
    <Placeholder loading={loading}>
      <VerticalSpacer>
        <HeadingActionsBar heading="Dashboard" />
        <HorizontalSpacer gap="section" alignItems="stretch">
          <StatCard
            title={stats?.totalQuotes?.title}
            summaryValue={stats?.totalQuotes?.summaryValue}
            summaryValueType={stats?.totalQuotes?.summaryValueType}
            statistics={stats?.totalQuotes?.statistics}
          />
          <StatCard
            title={stats?.quotesThisMonth?.title}
            summaryValue={stats?.quotesThisMonth?.summaryValue}
            summaryValueType={stats?.quotesThisMonth?.summaryValueType}
            statistics={stats?.quotesThisMonth?.statistics}
          />
          <StatCard
            title={stats?.policiesByStatus?.title}
            summaryValue={stats?.policiesByStatus?.summaryValue}
            summaryValueType={stats?.policiesByStatus?.summaryValueType}
            statistics={stats?.policiesByStatus?.statistics}
          />
          <StatCard
            title={stats?.policiesRenewed?.title}
            summaryValue={stats?.policiesRenewed?.summaryValue}
            summaryValueType={stats?.policiesRenewed?.summaryValueType}
            statistics={stats?.policiesRenewed?.statistics}
          />
          <StatCard
            title={stats?.totalActivePolicies?.title}
            summaryValue={stats?.totalActivePolicies?.summaryValue}
            summaryValueType={stats?.totalActivePolicies?.summaryValueType}
            statistics={stats?.totalActivePolicies?.statistics}
          />
          <StatCard
            title={stats?.totalCustomers?.title}
            summaryValue={stats?.totalCustomers?.summaryValue}
            summaryValueType={stats?.totalCustomers?.summaryValueType}
            statistics={stats?.totalCustomers?.statistics}
          />
          <StatCard
            title={stats?.totalGwp?.title}
            summaryValue={stats?.totalGwp?.summaryValue}
            summaryValueType={stats?.totalGwp?.summaryValueType}
            statistics={stats?.totalGwp?.statistics}
          />
          <StatCard
            title={stats?.conversionRate?.title}
            summaryValue={stats?.conversionRate?.summaryValue}
            summaryValueType={stats?.conversionRate?.summaryValueType}
            statistics={stats?.conversionRate?.statistics}
          />
          <StatCard
            title={stats?.totalClaims?.title}
            summaryValue={stats?.totalClaims?.summaryValue}
            summaryValueType={stats?.totalClaims?.summaryValueType}
            statistics={stats?.totalClaims?.statistics}
          />
        </HorizontalSpacer>
      </VerticalSpacer>
    </Placeholder>
  );
};
